// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconTheater = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M18 11a1 1 0 100-2 1 1 0 000 2M6 10a1 1 0 100-2 1 1 0 000 2m5-1a1 1 0 11-2 0 1 1 0 012 0m-3 4c-.87 0-1.612-.555-1.887-1.333l-1.885.667a4.001 4.001 0 007.544 0l-1.886-.667A2 2 0 018 13" />,
    <path
      fillRule="evenodd"
      d="M1 3h14v2h8v10c0 3.477-3.313 6-7 6-1.89 0-3.68-.663-4.978-1.777A6.4 6.4 0 018 20c-1.99 0-3.74-.97-4.971-2.28C1.806 16.42 1 14.686 1 13zm14 10.086V7h6v8c0 2.046-2.06 4-5 4-1.311 0-2.447-.389-3.304-1q.141-.138.275-.28a7.9 7.9 0 001.431-2.122 2 2 0 013.313.735l1.886-.666A4 4 0 0015 13.086M3 5v8c0 1.077.537 2.342 1.486 3.35C5.426 17.35 6.677 18 8 18s2.574-.65 3.514-1.65C12.463 15.343 13 14.078 13 13V5z"
    />
  );
export default SvgIconTheater;
